import { applyMiddleware, combineReducers, compose, createStore, Store } from 'redux';
import thunk from 'redux-thunk';
import { AppState } from './state/appState';
import { AppAction } from './actions/appAction';
import engagementsReducer from './reducers/engagementsReducer';
import { createJobReducer } from './reducers/createJobReducer';
import { jobsReducer } from './reducers/jobsReducer';
import { callAudioUploadReducer } from './reducers/callAudioUploadReducer';
import requestStatusReducer from './reducers/requestStatusReducer';
import { engagementsUsageReducer } from './reducers/engagementsUsageReducer';

const rootReducer = combineReducers<AppState>({
    engagements: engagementsReducer,
    engagementsUsage: engagementsUsageReducer,
    createJobsState: createJobReducer,
    jobs: jobsReducer,
    callAudioUpload: callAudioUploadReducer,
    requestStatus: requestStatusReducer
});

const composeEnhancers = (window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

// TODO: remove the any's here?
const store: Store<AppState, AppAction> = createStore<AppState, AppAction, any, any>(rootReducer, composeEnhancers(applyMiddleware(thunk)));

export default store;
